/** Vue.prototype.$FROM_MP */

export default {
  install(Vue) {
    Vue.prototype.$IS_FROM_MP = JSON.parse(sessionStorage.getItem('IS_FROM_MP'))
  }
}
